(function icon($, Drupal) {
  Drupal.theme.rutherfordIcon = function iconThemeFunction(icon) {
    const spriteUrl = `/themes/custom/rutherford/dist/img/sprite/sprite.svg`;

    return `<svg class="icon" focusable="false" role="presentation">
      <use xlink:href="${spriteUrl}#${icon}"></use>
    </svg>`;
  };
})(jQuery, Drupal);
